/**
 * Нормализация пользовательских описаний (ТЗ 6.5).
 *
 * Тексты услуг часто вставляют из мессенджеров: оттуда приезжают неразрывные
 * пробелы, двойные пробелы, хвостовые пробелы перед переносом и «лесенки»
 * из пустых строк. Декоративные маркеры (◆ ▪ ●) в текущих данных не
 * встречаются, но обрабатываются на случай появления — иначе они выглядят
 * как мусор посреди абзаца.
 *
 * Только нормализация пробелов и маркеров: разметку не трогаем и HTML не
 * генерируем — текст рендерится как обычная строка.
 */

const DECOR_BULLETS = /^[\s]*[◆◇▪▫■□●○★☆✦✧♦•]+[\s]*/gm;

export function sanitizeDescription(raw: string | null | undefined): string {
  if (!raw) return '';
  return raw
    // неразрывные и прочие экзотические пробелы → обычный
    .replace(/[     ]/g, ' ')
    // невидимые нулевой ширины — из копипасты
    .replace(/[​‌‍﻿]/g, '')
    .replace(/\r\n?/g, '\n')
    // декоративный маркер в начале строки → тире списка
    .replace(DECOR_BULLETS, '— ')
    // хвостовые пробелы перед переносом
    .replace(/[ \t]+\n/g, '\n')
    // «лесенка» из пустых строк → максимум одна
    .replace(/\n{3,}/g, '\n\n')
    // двойные пробелы внутри строки
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
}
